<template>
  <!-- 聊天记录 -->
  <div class="container" :class="{ progress: progress }">
    <div class="header">
      <p v-if="chatData" class="header-title">
        {{ owner_name }}
        <span>和&nbsp;&nbsp;</span>
        <span>{{ name }}&nbsp;&nbsp;</span>的聊天内容
      </p>
    </div>
    <div class="nav">
      <div class="nav-head">
        <el-radio-group
          v-model="msgType"
          :border="false"
          style="margin-bottom: 30px"
          @change="onTabchange"
        >
          <el-radio-button label="all" :disabled="loading"
            >全部</el-radio-button
          >
          <el-radio-button label="file" :disabled="loading"
            >文件</el-radio-button
          >
          <el-radio-button label="image" :disabled="loading"
            >图片</el-radio-button
          >
          <el-radio-button label="redpacket" :disabled="loading"
            >红包</el-radio-button
          >
          <el-radio-button label="voice" :disabled="loading"
            >语音</el-radio-button
          >
          <el-radio-button label="video" :disabled="loading"
            >视频</el-radio-button
          >
        </el-radio-group>
      </div>
      <div class="nav-right">
        <el-input
          style="width: 300px"
          placeholder="请输入关键词"
          v-model="q"
          class="input-with-select"
          prefix-icon="el-icon-search"
          @change="onSearch"
        >
          <el-button type="primary" slot="append" @click="onSearch"
            >查询</el-button
          >
        </el-input>
      </div>
    </div>
    <ul
      v-if="chatData"
      class="infinite-list"
      :infinite-scroll-immediate="false"
      v-infinite-scroll="load"
      style="overflow: auto; height: 560px"
    >
      <li v-for="(item, idx) of chatData" class="infinite-list-item" :key="idx">
        <template v-if="item.msgtype !== 'mixed'">
          <!-- 聊天窗口左侧 -->
          <div
            v-if="item.from === owner"
            class="chat-content"
            :class="{
              bg:
                item.msgtype === 'image' ||
                item.msgtype === 'voice' ||
                item.msgtype === 'card' ||
                item.msgtype === 'weapp' ||
                item.msgtype === 'location' ||
                item.msgtype === 'video' ||
                item.msgtype === 'redpacket' ||
                item.msgtype === 'docmsg' ||
                item.msgtype == 'link',
            }"
          >
            <div class="chat-person">
              <el-avatar shape="square" :src="item.avatar"></el-avatar>
            </div>
            <div class="chat-content-msg">
              <div class="msg-title">
                <span class="name">
                  {{ owner_name }}
                </span>
                <span class="time">{{ item.msgtime | formatDate }}</span>
              </div>
              <div class="msg-content-box">
                <span class="triangle"></span>
                <div class="msg-content">
                  <template v-if="item.msgtype === 'image'">
                    <el-image
                      fit="fill"
                      class="image"
                      :src="item.filepath"
                      placeholder="图片加载中.."
                      lazy
                      :preview-src-list="previewImgs"
                      @click.native="onPreviw(item)"
                    ></el-image>
                  </template>
                  <template v-if="item.msgtype === 'voice'">
                    <m-audio
                      class="voice"
                      :src="item.filepath"
                      alt
                      srcset
                    ></m-audio>
                  </template>
                  <template v-if="item.msgtype === 'file'">
                    <p class="link_desc">文件</p>
                    <p>
                      <el-link
                        type="primary"
                        :href="item.filepath"
                        target="self"
                        >{{ item.filename }}</el-link
                      >
                    </p>
                  </template>
                  <template v-if="item.msgtype === 'weapp'">
                    <div class="weapp">
                      <div class="weapp-displayname">
                        <i class="iconfont iconxiaochengxu"></i>
                        <span>{{ item.weapp_displayname }}</span>
                      </div>
                      <div class="weapp-title">{{ item.weapp_title }}</div>
                      <div>
                        <img src="../../assets/img/weapp.png" alt srcset />
                      </div>
                    </div>
                  </template>
                  <template v-if="item.msgtype === 'location'">
                    <img
                      :src="
                        `https://apis.map.qq.com/ws/staticmap/v2/?center=` +
                        item.latitude +
                        `,` +
                        item.longitude +
                        `&zoom=15&size=300*300&maptype=roadmap&markers=size:large|color:0xFFCCFF|label:k|` +
                        item.latitude +
                        `,` +
                        item.longitude +
                        `&key=6CTBZ-WPRC3-A7J3F-YJKJB-IBH32-G6F4J`
                      "
                      alt
                    />
                  </template>
                  <template v-if="item.msgtype === 'video'">
                    <video width="200px" height="auto" controls>
                      <source :src="item.filepath" type="video/mp4" />
                      <source :src="item.filepath" type="video/ogg" />
                      <source :src="item.filepath" type="video/webm" />
                      您的浏览器不支持 video 属性。
                    </video>
                  </template>
                  <template v-if="item.msgtype === 'card'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span>个人名片</span>
                      </div>
                      <div class="text item">
                        <p>{{ item.corpname }}</p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'docmsg'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span>微文档</span>
                      </div>
                      <div class="text item">
                        <p>
                          <el-link
                            type="primary"
                            :href="item.doc_url"
                            target="self"
                            >{{ item.doc_title }}</el-link
                          >
                        </p>
                        <p>
                          {{ item.doc_creator_name }}
                        </p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'redpacket'">
                    <div class="redpacket">
                      <div class="redpacket-box">
                        <div :title="item.packet_wish">
                          {{ item.packet_wish }}
                        </div>
                        <div>{{ item.packet_totalamount / 100 }}元</div>
                      </div>
                    </div>
                  </template>
                  <template v-if="item.msgtype === 'chatrecord'"
                    >转发了{{ item.chatrecord_title }}的聊天记录</template
                  >
                  <template v-if="item.msgtype == 'link'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <img
                          class="icons"
                          :src="item.link_image_url"
                          alt
                          srcset
                        />
                        <span>企业微信直播</span>
                      </div>
                      <div class="text item">
                        <p>
                          <el-link
                            type="primary"
                            :href="item.link_url"
                            target="self"
                            >{{ item.link_title }}</el-link
                          >
                        </p>
                        <p class="desc">{{ item.link_desc }}</p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'text'">
                    <span v-emotion="item.content"></span>
                  </template>
                </div>
              </div>
              <p v-if="item.is_revoke === 1" class="is_revoke">此消息被撤回</p>
            </div>
          </div>
          <!-- 聊天窗口右侧 -->
          <div
            v-else
            class="chat-content right"
            :class="{
              bg:
                item.msgtype === 'image' ||
                item.msgtype === 'voice' ||
                item.msgtype === 'card' ||
                item.msgtype === 'weapp' ||
                item.msgtype === 'location' ||
                item.msgtype === 'video' ||
                item.msgtype === 'redpacket',
            }"
          >
            <div class="chat-content-msg">
              <div class="msg-title">
                <span class="time">{{ item.msgtime | formatDate }}</span>
                <span class="name">{{ name }}</span>
              </div>
              <div class="msg-content-box">
                <span class="triangle"></span>
                <div class="msg-content">
                  <template v-if="item.msgtype === 'image'">
                    <el-image
                      fit="fill"
                      class="image"
                      :src="item.filepath"
                      placeholder="图片加载中.."
                      lazy
                      :preview-src-list="previewImgs"
                      @click.native="onPreviw(item)"
                    ></el-image>
                  </template>
                  <template v-if="item.msgtype === 'voice'">
                    <m-audio
                      class="voice"
                      :src="item.filepath"
                      alt
                      srcset
                    ></m-audio>
                  </template>
                  <template v-if="item.msgtype === 'file'">
                    <p class="link_desc">文件</p>
                    <p>
                      <el-link
                        type="primary"
                        :href="item.filepath"
                        target="self"
                        >{{ item.filename }}</el-link
                      >
                    </p>
                  </template>
                  <template v-if="item.msgtype === 'weapp'">
                    <div class="weapp">
                      <div class="weapp-displayname">
                        <i class="iconfont iconxiaochengxu"></i>
                        <span>{{ item.weapp_displayname }}</span>
                      </div>
                      <div class="weapp-title">{{ item.weapp_title }}</div>
                      <div>
                        <img src="../../assets/img/weapp.png" alt srcset />
                      </div>
                    </div>
                  </template>
                  <template v-if="item.msgtype === 'location'">
                    <img
                      :src="
                        `https://apis.map.qq.com/ws/staticmap/v2/?center=` +
                        item.latitude +
                        `,` +
                        item.longitude +
                        `&zoom=15&size=300*300&maptype=roadmap&markers=size:large|color:0xFFCCFF|label:k|` +
                        item.latitude +
                        `,` +
                        item.longitude +
                        `&key=6CTBZ-WPRC3-A7J3F-YJKJB-IBH32-G6F4J`
                      "
                      alt
                    />
                  </template>
                  <template v-if="item.msgtype === 'video'">
                    <video width="200px" height="auto" controls>
                      <source :src="item.filepath" type="video/mp4" />
                      <source :src="item.filepath" type="video/ogg" />
                      <source :src="item.filepath" type="video/webm" />
                      您的浏览器不支持 video 属性。
                    </video>
                  </template>
                  <template v-if="item.msgtype === 'card'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span>个人名片</span>
                      </div>
                      <div class="text item">
                        <p>{{ item.corpname }}</p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'docmsg'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span>微文档</span>
                      </div>
                      <div class="text item">
                        <p>
                          <el-link
                            type="primary"
                            :href="item.doc_url"
                            target="self"
                            >{{ item.doc_title }}</el-link
                          >
                        </p>
                        <p>
                          {{ item.doc_creator_name }}
                        </p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'redpacket'">
                    <div class="redpacket">
                      <div class="redpacket-box">
                        <div :title="item.packet_wish">
                          {{ item.packet_wish }}
                        </div>
                        <div>{{ item.packet_totalamount / 100 }}元</div>
                      </div>
                    </div>
                  </template>
                  <template v-if="item.msgtype === 'chatrecord'"
                    >转发了{{ item.chatrecord_title }}的聊天记录</template
                  >
                  <template v-if="item.msgtype == 'link'">
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <img
                          class="icons"
                          :src="item.link_image_url"
                          alt
                          srcset
                        />
                        <span>企业微信直播</span>
                      </div>
                      <div class="text item">
                        <p>
                          <el-link
                            type="primary"
                            :href="item.link_url"
                            target="self"
                            >{{ item.link_title }}</el-link
                          >
                        </p>
                        <p class="desc">{{ item.link_desc }}</p>
                      </div>
                    </el-card>
                  </template>
                  <template v-if="item.msgtype === 'text'">
                    <span v-emotion="item.content"></span>
                  </template>
                </div>
              </div>
              <p v-if="item.is_revoke === 1" class="is_revoke">此消息被撤回</p>
            </div>
            <div class="chat-person">
              <el-avatar shape="square" :src="item.avatar"></el-avatar>
            </div>
          </div>
        </template>
      </li>
      <el-divider v-if="chatData.length < 20">
        <span class="noMore">没有更多了哦 ~</span>
      </el-divider>
      <el-divider v-else>
        <i v-if="isMore" class="loading el-icon-loading"></i>
        <span class="noMore" v-if="!isMore">没有更多了哦 ~</span>
      </el-divider>
    </ul>
  </div>
</template>
<script>
import { getChatInfo, updateChatInfos } from "@/api/common.js";
export default {
  name: "chat",
  props: {
    owner: String,
    owner_name: String,
    name: String,
    external: String,
  },
  data() {
    return {
      chatData: [],
      msgType: "all",
      page: 1,
      isMore: true,
      loading: false,
      previewImgs: [],
      progress: true,
      q:''
    };
  },
  async mounted() {
    await this.updateChat();
    this.getChat();
  },
  methods: {
    async updateChat() {
      // 拉取最新的聊天记录
      await updateChatInfos({
        account_id: this.$store.state.user.token.account_id,
      });
    },
    async getChat() {
      if (!this.isMore) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const res = await getChatInfo({
          account_id: this.$store.state.user.token.account_id,
          from: this.owner,
          tolist: this.external,
          msgtype: this.msgType,
          page: this.page,
          content: this.q
        });
        this.loading = false;
        this.progress = false;
        if (res.code === 1) {
          this.chatData = this.chatData.concat(res.data);
          this.page++;
          return;
        } else {
          this.isMore = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    onSearch(){
      this.chatData = []
      this.page = 1
      this.getChat()
    },
    load() {
      this.getChat();
    },
    onTabchange() {
      this.initData();
      this.getChat();
    },
    initData() {
      this.chatData = [];
      this.page = 1;
      this.isMore = true;
      this.loading = false;
    },
    onPreviw(item) {
      this.previewImgs = [];
      this.previewImgs.push(item.filepath);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #f5f5f5;
}
.progress {
  cursor: progress;
}

// .header {
//   line-height: 40px;
//   background-color:#49B372;
//   .header-title {
//     margin-left: 20px;
//     color: #fff;
//   }
// }
.tabs .header{
  margin:0px;
}
/* tab切换 */
.nav {
  margin: 20px auto;
  display: flex;
  height: 40px;
  justify-content: space-between;
}
/*  tab栏去除el单选按钮边框  */
::v-deep .el-radio-button__inner {
  border: none !important;
}

/* 聊天窗口 */
.chat-content {
  padding: 0 24px;
  position: relative;
  display: flex;
  color: #343434;
  margin-bottom: 40px;
  .chat-person {
    margin-top: 4px;
    margin-right: 12px;
  }
  .chat-content-msg {
    .msg-title {
      .name,
      .time {
        margin-left: 8px;
        margin-right: 8px;
        font-size: 13px;
      }
    }
    .msg-content-box {
      display: inline-block;
      margin: 6px 4px;
      position: relative;
      word-wrap: break-word;
      word-break: break-all;
      .triangle {
        position: absolute;
        margin-left: -14px;
        margin-top: 5px;
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
        border-right: 8px solid #e5e5e5;
        border-bottom: 8px solid transparent;
        border-radius: 5px;
      }
      .msg-content {
        line-height: 1.425;
        .image {
          max-width: 240px;
          max-height: 320px;
        }
        .weapp {
          width: 200px;
          .weapp-displayname {
            margin-left: 2px;
            font-size: 12px;
            color: #999;
            & > span {
              margin-left: 4px;
            }
          }
          .weapp-title {
            margin-left: 4px;
            margin-top: 4px;
            font-size: 14px;
            color: #333;
          }
        }
        max-width: 60vw;
        padding: 7.5px 14px;
        background: #e5e5e5;
        border-radius: 6px;
      }
    }
    .is_revoke {
      margin-left: 8px;
      margin-top: 2px;
      font-size: 12px;
      color: rgb(255, 79, 79);
    }
  }
}
.chat-content.right {
  justify-content: flex-end;
  .chat-person {
    margin-left: 12px;
  }
  .chat-content-msg {
    .msg-title {
      display: flex;
      justify-content: flex-end;
      .name,
      .time {
        margin-left: 8px;
      }
    }
    .msg-content-box {
      position: relative;
      display: flex;
      justify-content: flex-end;
      .triangle {
        position: absolute;
        margin-right: -14px;
        border-left: 8px solid #49B372;
        border-right: 8px solid transparent;
      }
      .msg-content {
        color: #fff;
        background: #49B372;
      }
    }
    .is_revoke {
      text-align: right;
      margin-right: 8px;
    }
  }
}

::v-deep .el-divider__text {
  background: transparent;
}

::v-deep .right .x-audio-wrap.inline {
  background: #12baf3;
}
::v-deep .chat-content .x-audio-wrap.inline .x-time {
  color: #343434;
}
::v-deep .right .x-audio-wrap.inline .x-time {
  color: #fff;
}

/* 某些消息类型需要去除背景色，小三角 */
.chat-content.bg {
  .chat-content-msg {
    .msg-content-box {
      margin: 0;
      .triangle {
        border: transparent;
      }
      .msg-content {
        background: transparent;
      }
    }
  }
}

/* 加载中 */
.loading {
  color: #999;
  font-size: 24px;
}

/* 没有更多 */
.noMore {
  background-color: transparent;
  color: #999;
}

/* 音频播放 */
::v-deep .x-audio-wrap.inline {
  background: #fff;
}

/* 红包 */
.redpacket {
  width: 150px;
  height: 225px;
  background-image: url("../../assets/img/red-package.png");
  background-size: 100%;
}
.redpacket-box {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10%;
}
.redpacket-box > div:nth-child(1) {
  text-align: center;
  color: #e0b56a;
  font-size: 16px;
  margin-top: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.redpacket-box > div:nth-child(2) {
  text-align: center;
  font-size: 13px;
  margin-top: 65%;
}

/* 卡片类型 */
::v-deep .el-card__header .icons {
  width: 1.2em;
  height: 1.2em;
  border-radius: 3px;
  margin-right: 0.5em;
  vertical-align: -4px;
}
.item {
  margin-bottom: 24px;
  font-size: 13px;
  p {
    margin-bottom: 6px;
  }
}
::v-deep .el-card__body .desc {
  font-size: 12px;
  color: #999;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
  height: 140px;
}

.container{
  margin: 0 20px;
  background-color: #ffffff;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #49B372;
    border-color: #49B372;
    box-shadow: -1px 0 0 0 #49B372;
}
::v-deep .el-radio-button__inner:hover{
  color:#49B372;
}
.el-divider{
  height: 1px ;
  
}
</style>